import { AUTH_CONFIG_URL } from '@/auth/constants';

interface AuthConfigResponse {
  oidcDiscoveryUrl: string;
}

const AUTH_CONFIG_RETRY_DELAYS_MS = [1000, 2000];

const requestAuthConfig = () => fetch(AUTH_CONFIG_URL);

const fetchAuthConfig = async (): Promise<Response> => {
  for (const delayMs of AUTH_CONFIG_RETRY_DELAYS_MS) {
    try {
      return await requestAuthConfig();
    } catch (error) {
      const isNetworkError = error instanceof TypeError;

      if (!isNetworkError) {
        throw error;
      }

      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }

  return requestAuthConfig();
};

export const getDiscoveryUrl = async (): Promise<string> => {
  const response = await fetchAuthConfig();

  if (!response.ok) {
    throw new Error(`auth-config fetch failed: ${response.status}`);
  }

  const data = (await response.json()) as Partial<AuthConfigResponse>;

  if (!data.oidcDiscoveryUrl) {
    throw new Error('auth-config response missing oidcDiscoveryUrl');
  }

  return data.oidcDiscoveryUrl;
};
